const $$splitErrorComponentImporter = () => import('/home/ubuntu/actix-web-dome/ui/src/apps/main/routes/_main/user/account/set-info.tsx?tsr-split=errorComponent');
const $$splitComponentImporter = () => import('/home/ubuntu/actix-web-dome/ui/src/apps/main/routes/_main/user/account/set-info.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_main/user/account/set-info')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  errorComponent: lazyRouteComponent($$splitErrorComponentImporter, 'errorComponent')
});